import {Component, OnDestroy, OnInit} from '@angular/core';
import {FaceApiService} from '../../../../services/face-api/face-api.service';
import * as faceapi from '@vladmandic/face-api';

@Component({
  selector: 'app-face-landmark-detection',
  templateUrl: './face-landmark-detection.component.html',
  styleUrls: ['../../../../app.component.scss', '../faceapi.component.scss', './face-landmark-detection.component.scss']
})
export class FaceLandmarkDetectionComponent implements OnInit, OnDestroy {
  constructor(public faceApiService: FaceApiService) {
  }

  ngOnInit(): void {
    this.run();
  }

  ngOnDestroy(): void {
    this.faceApiService.stopStream();
  }

  async run() {
    const faceDetectorSelect = document.getElementById('selectFaceDetector') as HTMLSelectElement;
    const inputSizeSelect = document.getElementById('inputSize') as HTMLSelectElement;
    const videoEl = document.getElementById('inputVideo') as HTMLVideoElement;
    this.faceApiService.init(faceDetectorSelect, inputSizeSelect, videoEl);

    // load face detection and face expression recognition models
    await this.faceApiService.changeFaceDetector(this.faceApiService.TINY_FACE_DETECTOR);
    await faceapi.loadFaceLandmarkModel('assets/faceapi/weights/');
    this.faceApiService.changeInputSize(224);

    // try to access users webcam and stream the images
    // to the video element
    videoEl.srcObject = await navigator.mediaDevices.getUserMedia({video: {}});
  }

  async onPlay() {
    await this.faceApiService.play(async () => {
      try {
        const options = this.faceApiService.getFaceDetectorOptions();
        const ts = Date.now();
        const result = await faceapi.detectSingleFace(this.faceApiService.videoEl, options).withFaceLandmarks();
        this.faceApiService.updateTimeStats(Date.now() - ts);
        if (result) {
          const canvas = document.getElementById('overlay') as HTMLCanvasElement;
          const dims = faceapi.matchDimensions(canvas, this.faceApiService.videoEl, true);
          const resizedResult = faceapi.resizeResults(result, dims);
          if (!this.faceApiService.withoutBoxes) {
            faceapi.draw.drawDetections(canvas, resizedResult);
          }
          faceapi.draw.drawFaceLandmarks(canvas, resizedResult);
        }
      } catch (e) {
        console.log(':(');
      }
    });
  }

}
